export const isNegativeMinCount = (minCount) => minCount < 0;
export const isContainsData = (data) => {
    const {
        clientRequestId = '',
        recommendedListings = [],
        recommendedDestinations = [],
    } = data;
    return (
        !clientRequestId &&
        (!recommendedDestinations.length || !recommendedListings.length)
    );
};
